module.exports = __webpack_public_path__ + "static/img/stage_quote_draisin.6f4f667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article_2/stage_quotes/stage_quote_draisin.jpg
// module id = BkJH
// module chunks = 1